'use strict';

var RouteModuloBaseMixin = require("moduleFold/modulobase/scripts/mixins/RouteModuloBaseMixin");


/**
 * Registrazione delle route per il modulo bss/wizardlocalita
 *
 * @class
 * @param {type} $stateProvider
 * @param {type} $urlRouterProvider
 * @param {type} $locationProvider
 */

function WizardlocalitaRoutes($stateProvider, $urlRouterProvider, $locationProvider){

  var self = {
        $stateProvider: $stateProvider,
        stato: "wizardlocalita",
        url: "/wizardlocalita?view",
        template: require("../templates/maintpl.html"),
        controller: ["$http", "$q", "$timeout", "$state", "$stateParams", "DSFactory", "GridFactory", "ToolbarSrv", "identifica", "$scope", "$geolocation", "ActionFactory", "ErrorManager", "WizardlocalitaFunzioniAggiuntive", "FormDaHeaderFactory", "FieldFactory", "WizardHandler", require("../WizardlocalitaCtrl")],
        //controllerAs
        //middleware
        //data
        //identifica
    };

    angular.extend(self, RouteModuloBaseMixin.prototype);
    self.registra();
}

module.exports = WizardlocalitaRoutes;
